import type { JSX } from 'react';
import { DataTableFilters } from '@/shared/components/DataTableFilters';
import { TableSortSelect } from '@/shared/components/TableSortSelect';
import type { SortState, UseTableFiltersReturn } from '@/shared/types/table-filters.types';
import { refereeQuestionTableColumns } from '../config/refereeQuestionTableColumns';
import type { RefereeQuestion } from '../types/referee-question.types';

/** The parts of `useTableFilters` the toolbar binds to, minus the rows and the sort state. */
export type QuestionToolbarState = Omit<
  UseTableFiltersReturn<RefereeQuestion>,
  'filteredSorted' | 'sort' | 'setSort' | 'toggleSort'
>;

export interface QuestionToolbarProps {
  toolbar: QuestionToolbarState;
  sort: SortState | null;
  onSortChange: (sort: SortState | null) => void;
}

/** Search + filters drawer beside the sort select; one row from `md` up. */
export function QuestionToolbar({
  toolbar,
  sort,
  onSortChange,
}: QuestionToolbarProps): JSX.Element {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:flex-wrap md:items-end">
      <DataTableFilters
        columns={refereeQuestionTableColumns}
        filters={toolbar.filters}
        activeFilterCount={toolbar.activeFilterCount}
        onFilterChange={toolbar.setFilter}
        onClearFilters={toolbar.clearFilters}
        searchTerm={toolbar.searchTerm}
        onSearchChange={toolbar.setSearchTerm}
      />
      <TableSortSelect
        columns={refereeQuestionTableColumns}
        sort={sort}
        onSortChange={onSortChange}
      />
    </div>
  );
}
